/**
 * Builds multipart analysis bodies independently from the authenticated client.
 * This keeps scan_mode in one body source while pipeline remains a query concern.
 */

import { ScanMode, parseScanMode } from "./scanMode";

const normalizeAnalyzeViewType = (viewType?: string): string | undefined => {
  if (!viewType) return undefined;
  return viewType === "technical" ? "code" : viewType;
};

export const buildAnalyzeFormData = (
  projectId: string,
  drillDownNodeId?: string,
  viewType?: string,
  scanMode: ScanMode = ScanMode.IMPATIENT,
): FormData => {
  const formData = new FormData();
  formData.append("project_id", projectId);
  formData.append("scan_mode", parseScanMode(scanMode) ?? ScanMode.IMPATIENT);
  if (drillDownNodeId) {
    formData.append("drill_down_node_id", drillDownNodeId);
  }
  const normalizedViewType = normalizeAnalyzeViewType(viewType);
  if (normalizedViewType) {
    formData.append("view_type", normalizedViewType);
  }
  return formData;
};

export const buildAnalyzeZipFormData = (
  projectId: string,
  file: File | Blob,
  filename: string,
  isV2: boolean = true,
  connectMode: string = "auto",
  scanMode: ScanMode = ScanMode.IMPATIENT,
): FormData => {
  const formData = new FormData();
  formData.append("project_id", projectId);
  formData.append("file", file, filename);
  formData.append("filename", filename);
  formData.append("connect_mode", connectMode);
  formData.append("scan_mode", parseScanMode(scanMode) ?? ScanMode.IMPATIENT);
  formData.append("is_v2", String(isV2));
  formData.append("is_v3_batch", "true");
  return formData;
};
